<template>
    <div class="load-more">
        <footer class="load-more">
            <div class="loading-tip" v-if="pullUpState === 2">
                <span class="more-text">{{pullUpInfo.loadingText}}</span>
            </div>
            <div class="no-more-tip" v-if="pullUpState === 3">
                <span class="connecting-line"></span>
                <span class="no-more-text">{{pullUpInfo.noMoreText}}</span>
                <span class="connecting-line"></span>
            </div>
        </footer>
    </div>
</template>
<style lang="less">
    @import '../../assets/less/components/load-more.less';
</style>
<script>
/* globals swan */
import {mapState} from 'vuex';
import {getScrollTop, getScrollHeight, getWindowHeight} from '@/utils/decorate/scroll';
import {addEvent, removeEvent} from '@/utils/decorate/event';

export default {
    props: {
        pullUpState: {
            'type': Number,
            'default': 2
        },
        selectorId: String
    },
    data() {
        return {
            pullUpInfo: {
                loadingText: '正在加载...',
                noMoreText: '到底了'
            }
        };
    },
    mounted() {
        this.watchResize();
        return;
    },
    destroyed() {
        removeEvent(window, 'scroll', this.scrollLoadMore);
    },
    methods: {

        /**
         * 移动端滚动触发加载更多事件
         */
        mobileScroll() {
            addEvent(window, 'scroll', this.scrollLoadMore);
        },

        /**
         * 小程序滚动触发加载更多事件
         * 覆盖了 swan-decorator 文件里的 onPageScroll 函数
         *
         * @param {Object} e 目标对象
         */
        listenScroll(e) {
            if (this.pullUpState === 3) {
                return;
            }
            const scrollTop = e.scrollTop;
            const windowHeight = getWindowHeight();
            let query = swan.createSelectorQuery();
            let that = this;
            query.select(`#${this.selectorId}`).boundingClientRect(function (res) {
                const scrollHeight = res.height;
                if (scrollTop + windowHeight >= scrollHeight - 10) {
                    that.$emit('load', 'more');
                }
            }).exec();
        },
        // 监听屏幕的改变
        watchResize() {
            // 适配屏幕边界值
            const boundary = 768;
            let preScrWidth = document.documentElement.clientWidth;
            if (preScrWidth <= boundary) {
                // 当前为小屏，触发加载更多事件
                addEvent(window, 'scroll', this.scrollLoadMore);
            }
            let that = this;
            window.onresize = function () {
                let curScrWidth = document.documentElement.clientWidth;
                // 屏幕从小到大
                if (preScrWidth <= boundary && curScrWidth > boundary) {
                    // 移除加载更多事件
                    removeEvent(window, 'scroll', that.scrollLoadMore);
                    // 还原当前数据
                    that.$emit('load', 'less', 1);
                }
                // 屏幕从大到小
                if (preScrWidth > boundary && curScrWidth <= boundary) {
                    // 还原首页数据
                    that.$emit('load', 'less', 0);
                    // 触发加载更多事件
                    addEvent(window, 'scroll', that.scrollLoadMore);
                }
                preScrWidth = curScrWidth;
            };
        },
        // 滚动加载
        scrollLoadMore() {
            if (this.pullUpState === 3) {
                return;
            }
            if (getScrollTop() + getWindowHeight() >= getScrollHeight() - 10) {
                this.$emit('load', 'more');
            }
        }
    }
};
</script>
